export default __webpack_public_path__ + "static/loading-b6af4a89d6b0ec647b8416ff4b7416f8.gif";